import { getRepeatFields, setRepeatFields, getRepeatSwitch, setRepeatSwitchInfo, getRepeatWhiteList, setRepeatWhiteList } from '@/services/config'

const store = {
  namespaced: true,
  state: {
    // 查重字段
    repeatFields: [],
    // 全部敏感字段
    allRepeatFields: [],
    // 默认数据是否正在加载
    loadingContent: false,
    repeatSwitch: {},
    repeatWhiteList: []
  },
  mutations: {
    setRepeatFields (state, data) {
      state.repeatFields = data
    },
    setLoadingContent (state, type) {
      state.loadingContent = type
    },
    setAllRepeat (state, data) {
      state.allRepeatFields = data
    },
    setRepeatSwitch (state, data) {
      if ('projectid' in data) {
        state.repeatSwitch = Object.assign({}, data)
      } else {
        for (let i in data) {
          state.repeatSwitch[i] = data[i]
        }
      }
    },
    SET_WHITE_LIST (state, data) {
      state.repeatWhiteList = data
    }
  },
  actions: {
    // 获取查重字段
    async fetchRepeatData ({ commit }) {
      // commit('setLoadingContent', true)
      const chain = await getRepeatFields()
        .params({ edit: 0 })
        .onSuccess(raw => {
          commit('setRepeatFields', raw)
        })
        .onNetComplete(() => {
          // commit('setLoadingContent', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 获取所有查重字段
    async fetchAllRepeatData ({ commit }) {
      // commit('setLoadingContent', true)
      const chain = await getRepeatFields()
        .params({ edit: 1 })
        .onSuccess(raw => {
          commit('setAllRepeat', raw)
        })
        .onNetComplete(() => {
          // commit('setLoadingContent', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 获取查重开关
    async getRepeatSwitchData ({ commit }) {
      commit('setLoadingContent', true)
      const chain = await getRepeatSwitch()
        .onSuccess(res => {
          commit('setRepeatSwitch', res)
        }).onNetComplete(() => {
          commit('setLoadingContent', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 搜索字段
    async searchFields ({ commit }) {
      // commit('setLoadingContent', true)
      const chain = await getRepeatFields()
        .onNetComplete(() => {
          // commit('setLoadingContent', false)
        })
        .config({ tip: false })
      return chain
    },
    // 设置字段
    async setRepeatFields ({ commit }) {
      // commit('setLoadingContent', true)
      const chain = await setRepeatFields()
        .onNetComplete(() => {
          // commit('setLoadingContent', false)
        })
        .config({ tip: true })
      return chain
    },
    // 设置信息查重开关
    async setRepeatSwitchData ({ commit }, data) {
      const chain = await setRepeatSwitchInfo()
        .params(data)
        .config({ tip: false })
      return chain
    },
    async getRepeatWhiteList ({ commit }, data) {
      const chain = await getRepeatWhiteList()
      chain
        .params(data)
        .config({ tip: false })
        .onSuccess(payload => {
          commit('SET_WHITE_LIST', payload)
        })
      return chain.fetch()
    },
    async setRepeatWhiteList ({ commit }, data) {
      const chain = await setRepeatWhiteList()
      chain.params(data).fetch()
      return chain
    }
  }
}

export default store
